<!-- Modal Container -->
<div class="bg-white rounded-lg max-w-4xl w-full">
    <!-- Modal Header -->
    <div class="flex items-center justify-between py-4 border-b border-gray-200">
        <div>
            <h3 class="text-lg font-semibold text-gray-900">Commission</h3>
            <p class="text-sm text-gray-500">Amend commission detail</p>
        </div>
        <button type="button" class="text-gray-400 hover:text-gray-500 focus:outline-none" (click)="close()"
            aria-label="Close">
            <mat-icon class="!w-5 !h-5">close</mat-icon>
        </button>
    </div>

    <!-- Modal Body -->
    <div class="py-6 space-y-6">
        <!-- Commission Inputs -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Agent Commission -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Agent
                    <sup class="text-gray-500">{{
                        view.service.costCurrency
                        }}</sup>
                </label>
                <input type="text"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    [(ngModel)]="agentCommission" />
            </div>

            <!-- Consultant Commission -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">
                    Consultant
                    <sup class="text-gray-500">{{
                        view.service.priceCurrency
                        }}</sup>
                </label>
                <input type="text"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    [(ngModel)]="consultantCommission" />
            </div>
        </div>

        <!-- Divider -->
        <div class="border-t border-gray-200"></div>

        <!-- Confirmation Section -->
        <div class="bg-red-50 p-4 rounded-md text-center">
            <p class="text-red-600 font-bold mb-2">
                I confirm that all information has been checked,
                <u>double-checked</u> and is correct.
            </p>

            <label class="inline-flex items-center cursor-pointer mb-1">
                <mat-slide-toggle class="ml-2" [checked]="view.service.chk1" [color]="'primary'"
                    (change)="view.service.chk1 = !view.service.chk1"></mat-slide-toggle>

                <!-- <input 
              type="checkbox" 
              [(ngModel)]="view.service.chk1" 
              class="sr-only peer"
            >
            <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div> -->
                <span class="ml-2 text-sm font-medium text-gray-700">Allow changes</span>
            </label>

            <p class="text-xs text-gray-500">(Toggle switch to allow saving)</p>
        </div>
    </div>

    <!-- Modal Footer -->
    <div class="flex items-center justify-between px-6 py-4 border-t border-gray-200">
        <button type="button" class="text-gray-600 hover:text-gray-800 font-medium" (click)="close()">
            Close
        </button>

        <button *ngIf="LoggedInUser.agentType != 'AGENT'" [disabled]="!view.service.chk1" type="button"
            class="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="saveServiceItem()">
            Save Changes
        </button>
    </div>
</div>